import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const { FiInfo } = FiIcons;

const InfoTooltip = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        className="text-gray-400 hover:text-gray-600 transition-colors"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
      >
        <SafeIcon icon={FiInfo} className="w-4 h-4" />
      </button>
      
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            className="absolute z-50 w-64 p-3 text-sm bg-white rounded-lg shadow-lg border border-gray-200 text-gray-700"
            style={{ bottom: '100%', left: '50%', transform: 'translateX(-50%) translateY(-8px)' }}
          >
            <div className="relative">
              {text}
              <div className="absolute w-3 h-3 bg-white border-r border-b border-gray-200 transform rotate-45"
                   style={{ bottom: -10, left: 'calc(50% - 6px)' }}></div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default InfoTooltip;